import { PausableStudent } from ".";
import { SelectableStudent } from "@/components/StudentCheckboxSelector/StudentCheckboxSelector";
import { StudentClaim } from "@/api/studentClaims";

export function transformPauseStudents(
	students: PausableStudent[],
	classStableId: string,
	studentClaims: Record<string, StudentClaim>
): SelectableStudent[] {
	const selectableStudents = students.map((student) => {
		const claim = studentClaims[student.qoriaUserId];
		let isStudentClaimed = true;
		if (claim) {
			isStudentClaimed = claim.classId === classStableId;
		}
		return {
			value: student.username,
			label: `${student.fname} ${student.lname}`,
			isStudentClaimed: isStudentClaimed,
		} as SelectableStudent;
	});
	return selectableStudents;
}
